import Vue from 'vue'
import Request from "./utils/axios";
import {
	randomNoun,
	randomAdjective
} from "./utils/emailGenerator";
import {
	getItem,
	setItem
} from "./utils/storage"

const EventBus = new Vue({
	data() {
		return {
			email: {
				mailbox: 'test',
				name: ''
			},
			domain: 'mailinvicta.com',
			sessions: [],
			sessionData: {}
		}
	},
	created() {
		this.initMailbox()
	},
	methods: {
		initMailbox() {
			const session = getItem('mailinvicta'); //window.sessionStorage.getItem('mailinvicta');

			if (session) {
				this.sessionData = session; //JSON.parse(session)
				this.email = this.sessionData.email
				this.sessions = this.sessionData.sessions
			} else {
				this.newMailbox()
			}
		},
		newMailbox() {
			this.email = this.newEmail()
			// let sessions = this.sessions.slice()
			// console.log(sessions)
			this.sessions.unshift(this.email)
			// console.log(sessions)

			// Save to sessions
			this.sessionData = {
				email: this.email,
				sessions: this.sessions
			}
			setItem('mailinvicta', this.sessionData) //window.sessionStorage.setItem('mailinvicta', JSON.stringify(this.sessionData))
		},
		newEmail() {
			let noun1 = randomNoun();
			let noun2 = randomNoun();
			noun2 = noun2.substr(0, 1).toUpperCase() + noun2.substr(1);
			let adjective = randomAdjective();
			let email = {
				mailbox: adjective + noun1 + noun2,
				name: `${adjective}${noun1} ${noun2}`
			}
			return email
		},
		setMailbox(mailbox) {
			this.email = mailbox
			this.$emit('refresh-mailbox', true)
		},
		error(err) {
			console.log(err.response.data);
		}
	}
})

Object.defineProperties(Vue.prototype, {
	$bus: {
		get: () => EventBus
	},
	Request: {
		get: () => Request
	}
})
export default EventBus